module.exports = __webpack_public_path__ + "img/Jiangxi-speed.b6ec1a18.png";